import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    children?: React.ReactNode;
    description: string; 
    title: string;  
    extraStyle?: any; 
}; 

const DataBox: React.FC<Props> = ({ children, title, description, extraStyle }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    return (

      <Box sx={[{ 
          display: 'flex',
          flexDirection: 'column',
          width: '95%',
          height: 'auto', 
          padding: 2, 
          borderRadius: 3, 
          backgroundColor: colors?.container, 
          marginTop: 2, 
          marginLeft: 3, 
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
      }, extraStyle]}>

        <Box
            sx={{ 
                display: 'flex',
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                width: '95%', 
                padding: 1, 
                marginBottom: 1, 
            }}
        >
            <Box sx={{ fontWeight: 'bold' }}>{t(title)}</Box>

            <Box sx={{ marginLeft: 1, fontSize: 12 }}>{t(description)}</Box>

        </Box>

        {children}

      </Box>

  );

};

export default DataBox;